import { array, object, string } from "yup";
import { FormField } from "./types";
import { useRecipientsPivotValidationSchema } from "../shared";

const useValidationSchema = () =>
    useRecipientsPivotValidationSchema()
        .concat(
            object().shape({
                [FormField.Iso2]: array()
                    .of(string())
                    .min(1)
                    .nullable()
                    .label('Country ISO')
            })
        );

export default useValidationSchema;
